import { useState, useEffect, useRef } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { FeatureService } from "../../../../services/FeatureService";
import { REGEX_TEXT } from "../../../../util/RegEx";

export const useInsertLink = (open: boolean, changeAlert: ChangeAlertCallbackType, data?: any) => {
    const featureService = useRef<FeatureService>();
    const [isValidForm, setIsValidForm] = useState<boolean>(true);
    const [loading, setLoading] = useState(false);
    const [fileName, setFileName] = useState("");
    const [form, setForm] = useState({});
    const [error, setError] = useState({});
    const [updateProps, setUpdateProps] = useState([]);

    const onHandleChange = (key, e) => {
        let f = form;
        let u = updateProps;
        let value = e.target.value;

        f[key] = value;

        if(u.indexOf(key) === -1){
            u.push(key);
        };

        validateForm(f);
        setUpdateProps(JSON.parse(JSON.stringify(u)));
        setForm(JSON.parse(JSON.stringify(f)));
    };

    const checkName = (text) => {
        let e = error;

        if(text){
            if(text.length > 50){
                e["corporate_name"] = "El texto excede los 50 caracteres permitidos.";
                return false;
            } else {
                e["corporate_name"] = "";
                return true;
            }
        }
        setError(JSON.parse(JSON.stringify(e)));
    };

    const checkId = (text) => {
        if(text){
            if(!REGEX_TEXT.test(text)){
                setError({...error, company_id: "URL ID Inválido"});
                return false;
            } else if(text.length > 30){
                setError({...error, company_id: "El texto excede los 30 caracteres permitidos."});
                return false;
            } else {
                setError({...error, company_id: ""});
                return true;
            }
        }
    };

    const validateForm = (f) => {
        let check1 = checkName(f["corporate_name"]);
        let check2 = checkId(f["company_id"]);
        if (check1 && check2 && f["corporate_name"] && f["logo_url"] && f["company_id"] && !error["corporate_name"] && !error["logo_url"] && !error["company_id"] ) {
            setIsValidForm(false);
        } else {
            setIsValidForm(true);
        };
    };

    const onSelectFile = async (e) => {
        setLoading(true);
        let f = form;
        let file = e.target.files[0];

        if (!file) {
            changeAlert(true, "error", "Error en selección de archivo");
        } else if (["image/png", "image/jpeg", "image/jpg"].indexOf(file.type) === -1) {
            changeAlert(true, "error", "Error: El tipo de archivo permitido es imagen");
        } else {
            if (file) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    if (typeof reader.result === "string") {
                        const img = new Image();
                        img.onload = () => {
                            if (img.width > 500 || img.height > 500) {
                                setError({...error, logo_url: "Las dimensiones de la imagen exceden los límites permitidos (500x500 px)"});
                            } else {
                                setError({...error, logo_url: ""});
                                if (typeof reader.result === "string") {
                                    f["logo_url"] = reader.result.split(",")[1];
                                    setFileName(file.name);
                                    setForm(JSON.parse(JSON.stringify(f)));
                                    validateForm(f);

                                    let u = updateProps;
                                    if(u.indexOf("logo_url") === -1){
                                        u.push("logo_url");
                                    }
                                }
                            }
                        };
                        img.onerror = () => {
                            setError({...error, logo_url: "No se pudo cargar la imagen para verificar sus dimensiones"});
                        };
                        img.src = reader.result;
                    };
                };

                reader.readAsDataURL(file);
            };
        }
        setLoading(false);
    };

    useEffect(() => {
        setError({});
        setFileName(null);
        setIsValidForm(true);

        if (open && data) {
            setForm({
                uuid: data["uuid"],
                corporate_name: data["corporate_name"],
                logo_url: data["logo_url"],
                company_id: data["company_id"],
            });
            setUpdateProps(["uuid"]);
        } else if (open && !data) {
            setForm({});
            setUpdateProps([]);
        }
        featureService.current = new FeatureService(changeAlert);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, data]);

    return {
        form,
        error,
        loading,
        fileName,
        isValidForm,
        updateProps,
        onHandleChange,
        onSelectFile,
    };
};
